import api from './client';

export interface SleeperPreview {
  sleeperUser: {
    user_id: string;
    username: string;
    display_name: string;
    avatar: string | null;
  };
  // The single league we've chosen as the verification target. The user
  // changes THEIR team name INSIDE THIS LEAGUE to the verification code.
  verifyLeague: {
    league_id: string;
    name: string;
    season: string;
    avatar: string | null;
    total_rosters: number;
  };
  verificationCode: string;
}

export interface VerifyAndLinkResult {
  success: boolean;
  message: string;
  account?: {
    id: string;
    sleeper_user_id: string;
    current_username: string;
    is_verified: boolean;
  };
  matchedLeague?: {
    league_id: string;
    name: string;
    team_name: string;
  };
}

export const verificationApi = {
  // Preview a Sleeper account for linking. Returns the user's info, the
  // single league we've selected for verification, and the code they need
  // to use as their team name in that league.
  async preview(username: string): Promise<SleeperPreview> {
    const { data } = await api.get<SleeperPreview>(
      `/verification/preview/${encodeURIComponent(username)}`
    );
    return data;
  },

  // Verify and link. The backend checks only the specific league we picked
  // during preview — so leagueId is REQUIRED.
  async verifyAndLink(
    sleeperUserId: string,
    leagueId: string,
    verificationCode: string
  ): Promise<VerifyAndLinkResult> {
    const { data } = await api.post<VerifyAndLinkResult>(
      '/verification/verify-and-link',
      { sleeperUserId, leagueId, verificationCode }
    );
    return data;
  },
};
